import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { range } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ad-hoc-notifications',
  templateUrl: './ad-hoc-notifications.component.html',
  styleUrls: ['./ad-hoc-notifications.component.scss']
})
export class AdHocNotificationsComponent implements OnInit {

  selctType = 0;
  isSchedule: boolean = true;
  schedule: any = "";
  update_form;
  add_form;
  roleList: any = []
  submoduleList: any = [];
  moduleName: any = "";
  subModule: any = "";
  image: any = "";
  discription: any = "";
  program_id: any = ""
  submit: boolean = false
  startDate: any = "";
  endDate: any = "";
  timeDate: any = "";
  notificationList: any = []
  filedsList: any = [];
  browseImage: boolean = false
  upadateImage_url: any = "";
  fieldName: any = "";
  cursor_point: any = "";
  updatefieldName: any = "";
  isExcelUpload: boolean = false;
  addExcel: any;
  type: any = "";
  multiselectRole: any = [];
  uploadCount = 0;
  rejectedCount = 0;
  rejectedRdeason: any = [];
  excelFileName: any = ""


  updateModal = {
    based_on: '',
    role_id: [],
    excel: '',
    description: "",
    end_date: Date,
    id: "",
    image_url: "",
    module_item_id: "",
    notification_type: "",
    page_url: "",
    program_id: "",
    schedule: "",
    specific_time: Date,
    start_date: Date,
    title: "",
  }
  page = 1;
  data = []
  getPaginationCount: any;
  getPaginationLimit: any;
  defaultRoles: any = [];

  filteredDetails: any = { user_roles: [] }

  constructor(

    public modalService: NgbModal,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public fb: FormBuilder,
    private toast: ToastClientService,
    private xlsx: XlsxService,
    private exportExcelService: ExportExcelService,
    private datePipe: DatePipe

  ) {
    let userData: any = []
    // userData = JSON.parse(localStorage.getItem("program"))
    // this.program_id = userData.program_id
    this.program_id = '1';
  }

  ngOnInit() {
    this.formData();
    // this.getModule();
    // this.getNotification(this.page);
    // this.getFields();
  }
  getModule() {
    // this.apiService.get(this.apiConfig.adhocRole).subscribe((res: any) => {
    //   this.roleList = res.data;
    //   //
    // })
    this.apiService.get(this.apiConfig.getRoles)
      .subscribe((res: any) => {
        this.roleList = [];
        res.data.forEach(role => {
          role.id = role.role_id
          this.roleList.push(role);
        });
      }, err => {

      })
  }



  getNotification(page: any) {
    this.apiService.getHeaders(this.apiConfig.adhocNotificationList + `?page=${this.page}`)
      .subscribe((res: any) => {
        if (res.body.status == 200) {
          //
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          this.getPaginationLimit = res.headers.get("X-Pagination-Per-Page");
          this.notificationList = res.body.data;
          //
        }

      })
  }

  paginationClick(pageNumber: any) {
    //
    this.page = pageNumber;
    this.getNotification(pageNumber);
  }

  getFields() {
    this.apiService.get(this.apiConfig.addhocFileld + `?section_id=1&module=generic`).subscribe((res: any) => {
      this.filedsList = res.data.select_fields;
      //
    })
  }

  localCompleteDate: any;
  editItem(modal, notificationData) {
    if (notificationData.image_url != null) {
      this.browseImage = true;
    } else {
      this.browseImage = false;
    }
    //
    this.data = []
    this.type = 0
    this.excelFileName = "";
    this.selctType = 0;
    let role = { id: Number, role_name: String }
    this.updateModal = notificationData;




    this.localCompleteDate = this.datePipe.transform(this.updateModal.specific_time, 'yyyy-MM-ddTHH:mm');
    this.updateModal.specific_time = this.localCompleteDate

    if (this.updateModal.based_on == '1') {
      let roles = notificationData.role_id.split(',');
      for (let i = 0; i <= roles.length - 1; i++) {
        this.roleList.forEach((e: any) => {
          if (e.id == roles[i]) {
            role.id = e.id;
            role.role_name = e.value;
            this.data.push(JSON.parse(JSON.stringify(role)))
            //
          }
        });
      }
    }

    this.cursor_point = 0;
    //
    this.modalService.open(modal, {
      size: 'xl',
      centered: true,
      backdrop: "static",
    });

  }



  formData() {

    this.update_form = this.fb.group({
      title: ["", Validators.required],
      type: ["", Validators.required],
      discription: ["", Validators.required],
      path: ["", Validators.required],
      image: "",
      start_date: "",
      end_date: "",
      time_date: "",
      filed: "",
      schedule: ["", Validators.required],
    });

    this.add_form = this.fb.group({
      title: [""],
      discription: [""],
      path: ["", Validators.required],
      image: ["",],
      start_date: "",
      end_date: "",
      time_date: "",
      discriptionfiled: "",
      schedule: ["", Validators.required],
    });
  }


  saveNotification(update_form) {
    try {
      let role = { id: Number, role_name: String }
      if (this.updateModal.based_on == '1') {
        //this.filteredDetails.user_roles = [];
        let roles = (this.updateModal.role_id.toString()).split(',')
        for (let i = 0; i <= roles.length - 1; i++) {
          this.roleList.forEach((e: any) => {
            if (e.id == roles[i]) {
              this.filteredDetails.user_roles.push(roles[i])
            }
          });
        }
      }
    } catch {

    }
    if (this.updateModal.based_on == '1') {
      if (this.filteredDetails.user_roles.length == 0) {
        this.toast.Error("Plese select the role")
        return
      }
    }
    if (this.update_form.invalid) {
      this.toast.Error("please enter valid detail")
      return
    }
    if (this.updateModal.schedule == '5') {
      this.timeDate = this.updateModal.specific_time
      if (this.timeDate == '') {
        this.toast.Error("please select the date and time");
        return
      }
    }
    // if (this.updateModal.schedule != '5' && this.updateModal.schedule != '') {
    //   if (this.updateModal.start_date == null || this.updateModal.start_date == undefined) {
    //     this.toast.Error("please select start date");
    //     return
    //   }
    //   if (this.updateModal.end_date == null || this.updateModal.end_date == undefined) {
    //     this.toast.Error("please select end date");
    //     return
    //   }
    // }
    if (this.updateModal.based_on == '1') {
      this.addExcel = ""
    } else {
      this.updateModal.role_id = []
    }

    if (this.updateModal.based_on == '2') {
      let file = "";
      const payload = new FormData();
      payload.append('id', this.updateModal.id);
      payload.append('program_id', '1');
      payload.append('start_date', update_form.controls.start_date.value);
      payload.append('end_date', update_form.controls.end_date.value);
      payload.append('title', update_form.controls.title.value);
      payload.append('page_url', update_form.controls.path.value);
      payload.append('image_url', this.image);
      payload.append('description', update_form.controls.discription.value);
      payload.append('schedule_type', update_form.controls.schedule.value);
      payload.append('specific_time', update_form.controls.time_date.value);
      payload.append('select_type', update_form.controls.type.value);
      // payload.append('role_id', this.updateModal.role_id.toString());
      payload.append('role_id', this.filteredDetails.user_roles.toString());
      payload.append('excel_data', this.addExcel);


      this.apiService.upload(this.apiConfig.addhocupdateNotification, payload).subscribe((res: any) => {
        try {
          //
          if (res.body.data) {
            this.toast.Success("uploaded successfully")
            this.getNotification(this.page);
            this.excelFileName = "";
            this.modalService.dismissAll();
            this.isExcelUpload = true;
            this.rejectedRdeason = res.body.data.rejection_reason;
            this.uploadCount = res.body.data.product_generated;
            this.rejectedCount = res.body.data.reject_count;
          }
        } catch {

        }
      }, err => {
        this.toast.Error(err)
      })
    } else {

      var payload = {
        'id': this.updateModal.id,
        'program_id': this.program_id,
        'start_date': update_form.controls.start_date.value,
        'end_date': update_form.controls.end_date.value,
        'title': update_form.controls.title.value,
        'page_url': update_form.controls.path.value,
        'image_url': this.image,
        'description': update_form.controls.discription.value,
        'schedule_type': update_form.controls.schedule.value,
        'specific_time': update_form.controls.time_date.value,
        'select_type': update_form.controls.type.value,
        'role_id': this.filteredDetails.user_roles.toString(),
        'excel_data': this.addExcel
      }
      //
      this.apiService.post(this.apiConfig.addhocupdateNotification, payload).subscribe((res: any) => {
        this.toast.Success("uploaded successfully")
        this.getNotification(this.page);
        this.excelFileName = "";
        this.modalService.dismissAll()
      }, err => {
        this.toast.Error(err)
      })
    }

  }


  addNotification() {
    this.submit = true;

    if (this.type == '') {
      this.toast.Error("Plese select the type")
      return
    }
    if (this.type == '1') {
      if (this.filteredDetails.length == 0) {
        this.toast.Error("Plese select the role")
        return
      }
    } else {
      if (this.addExcel == undefined) {
        this.toast.Error("Plese Upload Excel")
      }
    }
    console.log(this.add_form, "add_form");

    // ***********

    // if (this.add_form.invalid) {
    //   this.toast.Error("please enter valid detail")
    //   return
    // }

    // **********

    if (this.schedule == 5) {
      if (this.timeDate == '') {
        this.toast.Error("please select the date and time");
        return
      }
    }



    // if (this.schedule != 5 && this.schedule != '') {
    //   if (this.startDate == '') {
    //     this.toast.Error("please select start date");
    //     return
    //   }
    //   if (this.endDate == '') {
    //     this.toast.Error("please select end date");
    //     return
    //   }
    // }

    if (this.type == '2') {
      const formData = new FormData();
      formData.append('excel_data', this.addExcel);
      formData.append('program_id', this.program_id);
      formData.append('start_date', this.add_form.controls.start_date.value);
      formData.append('end_date', this.add_form.controls.end_date.value);
      formData.append('title', this.add_form.controls.title.value);
      formData.append('path', this.add_form.controls.path.value);
      formData.append('image', this.image);
      formData.append('description', this.add_form.controls.discription.value);
      formData.append('trigger_time', this.add_form.controls.schedule.value);
      formData.append('specific_time', this.add_form.controls.time_date.value);
      this.apiService.upload(`${this.apiConfig.uploadNotification}?program_id=${this.program_id}`, formData)
        .subscribe((res: any) => {
          try {
            //
            if (res.body.data) {
              this.isExcelUpload = true;
              this.excelFileName = "";
              this.toast.Success("uploaded successfully")
              this.add_form.reset();
              this.add_form.controls.title.value = "";
              this.add_form.controls.discription.value = "";
              this.add_form.controls.path.value = "";
              this.add_form.controls.image.value = "";
              this.add_form.controls.start_date.value = "";
              this.add_form.controls.end_date.value = "";
              this.add_form.controls.time_date.value = "";
              this.add_form.controls.discriptionfiled = "";
              this.add_form.controls.schedule = "";
              this.uploadCount = res.body.data.success_count;
              this.rejectedCount = res.body.data.reject_count;
              this.rejectedRdeason = res.body.data.rejection_reason;
              this.resetForm();
              this.schedule = "";
              this.localCompleteDate = "";

              this.getNotification(this.page);

            }
          } catch {

          }


        }, err => {
          this.toast.Error(err)
        })
    } else if (this.type == '1') {
      let payload = {
        program_id: parseInt(this.program_id),
        schedule_type: this.add_form.controls.schedule.value,
        start_date: this.add_form.controls.start_date.value,
        end_date: this.add_form.controls.end_date.value,
        title: this.add_form.controls.title.value,
        description: this.add_form.controls.discription.value,
        image_url: this.image,
        page_url: this.add_form.controls.path.value,
        specific_time: this.add_form.controls.time_date.value,
        // role_id: this.multiselectRole.toString()
        role_id: this.filteredDetails.user_roles.toString()
      }
      this.apiService.post(this.apiConfig.addhocuploadrolewise, payload)
        .subscribe((res: any) => {
          try {
            if (res.body.status == 200) {
              this.submit = false;
              this.toast.Success(res.body.data.message);
              this.getNotification(this.page);
              this.resetForm();
              this.schedule = "";
            }
          } catch {

          }
        }, err => {
          this.toast.Error(err)
        })
    }

  }

  resetForm() {
    this.type = '';
    this.selctType = 0;
    this.multiselectRole = [];
    this.add_form.reset();
    this.add_form.controls.title.value('');
    this.add_form.controls.path.value('');
    this.add_form.controls.image.value('');
    this.add_form.controls.schedule.value('');
    this.add_form.controls.discription.value('');
    this.add_form.controls.start_date.setErrors(null);
    this.add_form.controls.end_date.setErrors(null);
    this.add_form.controls.time_date.setErrors(null);
    this.add_form.updateValueAndValidity();
  }

  changeListener($event, num: any): void {
    this.readThis($event.target, num);
  }

  readThis(inputValue: any, num): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      if (num == 1) this.image = myReader.result;
      if (num == 2) this.upadateImage_url = myReader.result;
      // 
    }
    myReader.readAsDataURL(file);
  }

  cursorEvent(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      let caretPos = oField.selectionStart;
      this.cursor_point = caretPos;
    }
  }

  appendDynamicDataInMsg(selected_field, discription, num) {
    if (num == 1) {
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.discription += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.discription.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.discription.substr(this.cursor_point); // Gets the secound part
          this.discription = firstText + selected_field + secoundText;
        } else {
          this.discription += selected_field;
        }
      }

    } else {
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = this.updateModal.description.length;
      if (leng == this.cursor_point) {
        this.updateModal.description += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText: any = this.updateModal.description.substr(0, this.cursor_point); // Gets the first part
          var secoundText: any = this.updateModal.description.substr(this.cursor_point); // Gets the secound part
          this.updateModal.description = firstText + selected_field + secoundText;
        } else {
          this.updateModal.description += selected_field;
        }
      }
    }
  }

  closeImage() {
    this.browseImage = false;
    this.updateModal.image_url = "";
  }
  modalDismiss() {
    this.selctType = 0;
    this.type = ""
    this.modalService.dismissAll();
    this.isExcelUpload = false;
    this.browseImage = false;
    this.getNotification(this.page);
    this.excelFileName = "";
  }

  getType(type) {
    this.selctType = type;
    this.type = type
  }
  ExcelInput() {
    let excel = document.getElementById("id_excel").click();
  }
  uploadExcel(event) {
    //
  }


  // selectedItem(e: any, no: any) {
  //   if (no == 1) {
  //     this.multiselectRole = [];
  //     e.forEach((element) => {
  //       this.multiselectRole.push(element.id)
  //     });
  //     //
  //   }
  //   else {
  //     this.updateModal.role_id = [];
  //     e.forEach((element) => {
  //       this.updateModal.role_id.push(element.id)
  //     });
  //     // 
  //   }
  // }

  selectedItem(eve) {
    this.formateFillters(eve, "user_roles");
    //
  }
  formateFillters(data, name) {

    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1)
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach(element => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }




  showuploadTemplateModal(modal) {
    this.modalService.open(modal, {
      centered: true,
      backdrop: "static",
    });
  }


  uploadXlsx(event) {
    let fileName;
    let size;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      fileName = file.name;
      this.excelFileName = file.name;
      //
      size = (file.size / 1024 / 1024).toFixed(2) + ' MB';
      //
      this.addExcel = file;
      // this.bulkApproveUsers(file);
    } else {
      this.toast.Error("File has not imported!");
      return
    }
    if (this.type == 2) this.modalService.dismissAll();
  }

  // bulkApproveUsers(file) {
  //   const formData = new FormData();

  //   formData.append('excel_data', file);
  //   this.apiService.upload(this.apiConfig.adhocuploadExcel, formData)
  //     .subscribe((res: any) => {
  //       
  //       this.isExcelUpload = true;

  //     }, err => {
  //       this.toast.Error(err.message)
  //     });
  // }


  downloadExcel() {
    this.exportExcelService.communPrintHeaders(["Mobile Number", "Description", "Title"]);
    this.modalService.dismissAll();
  }
  OpenReasonModel(reasonTemplate) {
    this.modalService.open(reasonTemplate, {
      size: 'xl',
      centered: true,
      backdrop: "static",
    })
  }
  openUpdateExcel(updateExcel) {
    document.getElementById("updateExcel").click();
  }

  viewImage(modal, image) {
    this.modalService.open(modal, {
      centered: true,
      size: 'md',
      backdrop: false
    })

    const imgElement = document.getElementById('modalImage') as HTMLImageElement
    if (imgElement) {
      imgElement.src = image
    }
  }

  closeModal() {
    this.modalService.dismissAll()
  }
}

